'use client';

import { useState } from 'react';

/**
 * Tap/click affordance for the server-rendered contribution calendar: one
 * delegated listener instead of ~370 hydrated cells. Hover users get native
 * SVG <title> tooltips; this covers touch (and click) with an aria-live line.
 */
export function GraphTapDetail({ children }: { children: React.ReactNode }) {
  const [detail, setDetail] = useState<string | null>(null);

  const onClick = (event: React.MouseEvent) => {
    const rect = (event.target as Element).closest?.('rect[data-date]');
    if (!(rect instanceof SVGElement)) return;
    const date = rect.getAttribute('data-date');
    const count = Number(rect.getAttribute('data-count'));
    if (!date || Number.isNaN(count)) return;
    const [y, m, d] = date.split('-');
    const text = `${count} contribution${count === 1 ? '' : 's'} on ${d}.${m}.${y}`;
    setDetail((prev) => (prev === text ? null : text));
  };

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: delegated enhancement; cells stay reachable via native titles
    // biome-ignore lint/a11y/useKeyWithClickEvents: hover and AT users get the same data from the SVG titles
    <div onClick={onClick}>
      {children}
      <p
        className="min-h-4 font-sans text-xs text-muted-foreground"
        aria-live="polite"
      >
        {detail}
      </p>
    </div>
  );
}
